module.exports = __webpack_public_path__ + "static/media/genderless.5784780a.svg";